<app-cargando *ngIf="cargando"></app-cargando>

<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3 class="card-title mb-0"><i class="fas fa-file-code me-2"></i>Exportar XML — Pagos Recibidos (DI API)</h3>
            </div>

            <div class="card-body">
                <!-- Buscador -->
                <div class="row mb-4">
                    <div class="col-md-3">
                        <label class="form-label fw-bold">Buscar por DocNum</label>
                        <input [(ngModel)]="searchDocNum" type="number" class="form-control" placeholder="N° Documento">
                    </div>
                    <div class="col-md-3">
                        <label class="form-label fw-bold">Buscar por DocEntry</label>
                        <input [(ngModel)]="searchDocEntry" type="number" class="form-control" placeholder="DocEntry">
                    </div>
                    <div class="col-md-6 d-flex align-items-end gap-2">
                        <button class="btn btn-primary" (click)="buscar()">
                            <i class="fas fa-search me-1"></i>Buscar
                        </button>
                        <button class="btn btn-outline-secondary" (click)="limpiar()">
                            <i class="fas fa-redo me-1"></i>Últimos 100
                        </button>
                    </div>
                </div>

                <!-- Mensajes -->
                <div class="alert alert-info" *ngIf="mensaje && !cargando">
                    <i class="fas fa-info-circle me-1"></i>{{ mensaje }}
                </div>
                <div class="alert alert-danger" *ngIf="mensajeError && !cargando">
                    <i class="fas fa-exclamation-triangle me-1"></i>{{ mensajeError }}
                </div>

                <!-- Tabla de pagos -->
                <div class="table-responsive" *ngIf="pagos.length > 0 && !cargando">
                    <table class="table table-sm table-striped table-hover table-bordered">
                        <thead class="table-dark">
                            <tr>
                                <th>DocEntry</th>
                                <th>DocNum</th>
                                <th>CardCode</th>
                                <th>CardName</th>
                                <th>Fecha</th>
                                <th class="text-end">Total</th>
                                <th>Moneda</th>
                                <th style="width: 130px" class="text-center">Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let p of pagos">
                                <td><span class="badge bg-secondary">{{ p.DocEntry }}</span></td>
                                <td><strong>{{ p.DocNum }}</strong></td>
                                <td>{{ p.CardCode }}</td>
                                <td>{{ p.CardName }}</td>
                                <td>{{ p.DocDate | date: 'dd/MM/yyyy' }}</td>
                                <td class="text-end">{{ p.DocTotal | number:'1.0-0' }}</td>
                                <td>{{ p.DocCurr }}</td>
                                <td class="text-center">
                                    <button class="btn btn-sm btn-success"
                                            (click)="descargarXML(p)"
                                            [disabled]="descargando[p.DocEntry]">
                                        <span *ngIf="!descargando[p.DocEntry]">
                                            <i class="fas fa-download me-1"></i>XML
                                        </span>
                                        <span *ngIf="descargando[p.DocEntry]">
                                            <span class="spinner-border spinner-border-sm me-1" role="status"></span>...
                                        </span>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Sin resultados -->
                <div *ngIf="pagos.length === 0 && !cargando && !mensaje && !mensajeError" class="text-center text-muted py-5">
                    <i class="fas fa-inbox fa-3x mb-3 d-block"></i>
                    No hay pagos para mostrar
                </div>
            </div>
        </div>
    </div>
</div>
